import React from "react";
const icon = (
  <svg
    width="50"
    height="44"
    viewBox="0 0 50 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6.375C0 2.92773 2.80273 0.125 6.25 0.125H43.75C47.1973 0.125 50 2.92773 50 6.375V37.625C50 41.0723 47.1973 43.875 43.75 43.875H6.25C2.80273 43.875 0 41.0723 0 37.625V6.375ZM31.6211 16.7754C31.1816 16.1309 30.459 15.75 29.6875 15.75C28.916 15.75 28.1836 16.1309 27.7539 16.7754L19.2578 29.2363L16.6699 26.0039C16.2207 25.4473 15.5469 25.125 14.8438 25.125C14.1406 25.125 13.457 25.4473 13.0176 26.0039L6.76758 33.8164C6.20117 34.5195 6.09375 35.4863 6.48438 36.2969C6.875 37.1074 7.69531 37.625 8.59375 37.625H17.9688H21.0938H41.4062C42.2754 37.625 43.0762 37.1465 43.4766 36.375C43.877 35.6035 43.8281 34.6758 43.3398 33.9629L31.6211 16.7754ZM10.9375 15.75C13.5254 15.75 15.625 13.6504 15.625 11.0625C15.625 8.47461 13.5254 6.375 10.9375 6.375C8.34961 6.375 6.25 8.47461 6.25 11.0625C6.25 13.6504 8.34961 15.75 10.9375 15.75Z"
      fill="#8803E9"
    />
  </svg>
);

export default icon;
